import { Component } from '@angular/core';
import { SearchParams } from '../../../search/models/search-params.model';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DataTableConfig } from '../../../search/models/data-table-config';
import { SearchStatus } from '../../../search/models/search-status.model';
import { SearchCriteria, Condition, Clause } from '../../../search/models/search-filter-model';
import { AlertService } from 'sce-core';
import { SearchService } from '../../../search/search.service';
import { DataTableEditorService } from '../../../search/results/data-table-editor.service';
import { Observable } from 'rxjs/Observable';
import { SimpleEntityDataService } from '../../../services/searchable-entity/simple-entity/simple-entity-data.service';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'lfwms-move-orders-popup',
  templateUrl: './move-orders-popup.component.html',
  styleUrls: ['./move-orders-popup.component.css'],
  providers: [SimpleEntityDataService]
})
export class MoveOrdersPopupComponent {

  public moveOrderPopupSearchService: SearchService;
  public showTable: boolean = true;
  private http$ = this.coreServiceRegistry.http$;
  public resourceService = this.coreServiceRegistry.resourceService;
  public selectedTab: string;
  public waveKeyValue: string;
  public primaryKeyName: string;
  public primaryKeyValue: string;
  public isNewOrExistingChkd: string = 'N'; // N indiactes move order to existing load or shipref Key
  public existingLoadOrShiprefValue: string; // existing load or shipref value to move the orders
  public orderCount: number = 0; // no of rows selected
  public caseCount: number = 0; // if load tab case count = sum of caseCnt of selected rows, if shipref tab case count = sum of totalCartons of selected rows
  public grossWeight: number = 0; // gross weight = sum of weight of selected rows
  public cube: number = 0; // cube = sum of cube of selected rows
  public eventSubject = new Subject<any>();

  constructor(
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService,
    private dataService: SimpleEntityDataService
  ) { }

  public initializeComponents(primaryKeyName: string, primaryKeyValue: string, waveKeyValue: string, selectedTab: string) {
    this.selectedTab = selectedTab;
    this.waveKeyValue = waveKeyValue;
    this.primaryKeyName = primaryKeyName;
    this.primaryKeyValue = primaryKeyValue;
    const tabledId = primaryKeyName === 'loadKey' ? 'moveordloadtd' : 'moveordmboltd';
    this.moveOrderPopupSearchService = this.createSearchService(tabledId);
    this.moveOrderPopupSearchService.setSearchCriteria(this.createSearchCriteria(primaryKeyName, primaryKeyValue));
    this.moveOrderPopupSearchService.fetchMetadata().subscribe((metaData: any) => {
      this.moveOrderPopupSearchService.performSearch();
    });
  }

  private createSearchService(tableId: string): SearchService {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    searchParams.dataTableConfig = tableConfig;
    searchParams.alertService = this.alertService;
    const tableEditor: DataTableEditorService = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    searchParams.tableEditor = tableEditor;
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    return searchService;
  }

  public createSearchCriteria(primaryKeyName: string, primaryKeyValue: string) {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;

    const defaultCondition1 = this.createSearchCondition(1);
    defaultCondition1.isReadOnly = true;
    defaultCondition1.isMandatory = true;
    defaultCondition1.operator = '';
    const defaultClause1 = new Clause();
    defaultClause1.column = primaryKeyName;
    defaultClause1.value = primaryKeyValue;
    defaultClause1.operation = '=';
    defaultClause1.logicalOperation = '';

    defaultCondition1.clauses = [defaultClause1];
    defaultSearchCriteria.conditions.push(defaultCondition1);
    return defaultSearchCriteria;
  }

  /**
   * create an instance of condition
   * @param id
   */
  protected createSearchCondition(id: any) {
    const defaultCondition = new Condition();
    defaultCondition.id = id;
    defaultCondition.displayMode = 'VIEW';
    return defaultCondition;
  }

  /* event is captured from result data table component on select of checkbox,
  if the row level checkbox is enabled or disabled then the rowIndex also passed */
  public onSelectCheckbox(rowIndex: any) {
    const selectedRows: any[] = this.moveOrderPopupSearchService.getSelectedRows();
    this.orderCount  = this.moveOrderPopupSearchService.getSelectedRows().length;
    this.caseCount = 0;
    this.grossWeight = 0;
    this.cube = 0;
    if (selectedRows.length > 0) {
      selectedRows.forEach(row => {
        if (this.selectedTab === 'load') {
          this.caseCount += parseInt(row.cells['caseCnt'].cVal, 10);
        } else {
          this.caseCount += parseInt(row.cells['totalCartons'].cVal, 10);
        }
        this.grossWeight += parseInt(row.cells['weight'].cVal, 10);
        this.cube += parseInt(row.cells['cube'].cVal, 10);
      });
    }
  }

  /**
   * submit
   */
  public submit() {
    const requiredDetailsForMoveOrder = [];
    const noOfLineItems = this.moveOrderPopupSearchService.getPagedData().pageDefinition.recordCount;
    if (noOfLineItems === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_no_detail'));
      return;
    }
    const selectedRows: any[] = this.moveOrderPopupSearchService.getSelectedRows();
    if (selectedRows.length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_sel_detail'));
      return;
    }
    if (this.selectedTab === 'load') {
      if (this.isNewOrExistingChkd === 'N' && !this.existingLoadOrShiprefValue) {
        this.alertService.clearAll().error(this.resourceService.get('err_man_load_key'));
        return;
      } else {
        selectedRows.forEach(element => {
          requiredDetailsForMoveOrder.push(
            {
              'waveKey': this.waveKeyValue,
              'loadKey': this.primaryKeyValue,
              'loadLineNumber': element.cells['loadLineNumber'].cVal,
              'toLoadKey': this.existingLoadOrShiprefValue,
              'createNew': this.isNewOrExistingChkd,
              'totalSelectedKeys': '',
              'warningNo': '',
              'proceedWithWarning': 'Y'
            }
          );
        });
      }
    } else {
      if (this.isNewOrExistingChkd === 'N' && !this.existingLoadOrShiprefValue) {
        this.alertService.clearAll().error(this.resourceService.get('err_man_ship_ref'));
        return;
      } else {
        selectedRows.forEach(element => {
          requiredDetailsForMoveOrder.push({
            'waveKey': this.waveKeyValue,
            'mbolKey': this.primaryKeyValue,
            'mbolLineNumber': element.cells['mbolLineNumber'].cVal,
            'toMBOLKey': this.existingLoadOrShiprefValue,
            'createNew': this.isNewOrExistingChkd,
            'totalSelectedKeys': '1',
            'warningNo': '',
            'proceedWithWarning': 'Y'
          }
          );
        });
      }
    }
    const moveOrderEvent = { 'type': 'moveorder', 'selectedItemDetails': requiredDetailsForMoveOrder };
    this.notifyEvent(moveOrderEvent);
  }

  public notifyEvent(value: any) {
    this.eventSubject.next(value);
  }

  public receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/wave-control-popups/move-orders-popup/move-orders-popup.component.ts